const LEFT = 'left';
const RIGHT = 'right';
const TOP = 'top';
const BOTTOM = 'bottom';
const CENTAR = 'centar';

export const postionsConstants = {
	LEFT,
	RIGHT,
	TOP,
	BOTTOM,
	CENTAR,
};
